import { FormItemTypes, IDictionary } from '@bimser/core';
import { JSX } from 'react';
import { IPropertyField } from '../../../entities/common';
import { IDataBoundControlProperties } from '../entities/IDataBoundControlProperties';
import VisualControl from './VisualControl';

export default class DataBoundControl extends VisualControl {
	readOnly: boolean;

	constructor() {
		super();

		this.readOnly = false;
	}

	__loadProperties(data: IDataBoundControlProperties) {
		super.__loadProperties(data);

		this.__proxyChanged.readOnly = data.readOnly;
	}

	__getPropertyFields(): IPropertyField[] {
		const fields = super.__getPropertyFields();
		return [
			...fields,
			{
				name: 'readOnly',
				type: 'boolean',
				common: true
			}
		];
	}

	__isReadOnly() {
		if (this.__form) {
			return this.readOnly || this.__form.readOnly || this.__checkIfParentControlReadOnly();
		}
	}

	__getParentControl(name: string) {
		const parentSectionId = this.__form.view.getIn(['entities', 'items', name, 'parentId']);
		const parentId = this.__form.view.getIn(['entities', 'items', parentSectionId, 'parentId']);
		return this.__form.items.get(parentId);
	}

	__checkIfParentControlReadOnly(name: string = this.name): boolean {
		if (this.controlType === FormItemTypes.EContainerTypes.Form) {
			return false;
		}

		const parentId: string = this.__form.view.getIn(['entities', 'items', name, 'parentId']);
		const parentControl =
			this.__form.displayMode === 'preview'
				? this.__getParentControl(parentId)
				: this.__form.items.get(parentId);

		if (!parentId || !parentControl) {
			return false;
		}

		const containerTypes = [
			FormItemTypes.EControlTypes.Collapse,
			FormItemTypes.EControlTypes.Tabs,
			FormItemTypes.EControlTypes.InputGroup,
			FormItemTypes.EContainerTypes.Form,
			FormItemTypes.EControlTypes.Panel,
			FormItemTypes.EControlTypes.ScrollView
		];

		if (containerTypes.includes(parentControl.type as FormItemTypes.EControlTypes)) {
			const isReadOnly = parentControl.getIn(['properties', 'readOnly']);

			if (isReadOnly) {
				return true;
			}
		} else if (FormItemTypes.EControlTypes.Tab === parentControl.type) {
			const isTabReadOnly: boolean = parentControl.getIn(['properties', 'readOnly']);

			const parentControlsParentId: string = this.__form.view.getIn([
				'entities',
				'items',
				parentControl.id,
				'parentId'
			]);

			const isTabsReadOnly: boolean = this.__form.items.getIn([
				parentControlsParentId,
				'properties',
				'readOnly'
			]);

			if (isTabReadOnly || isTabsReadOnly) {
				return true;
			}
		}

		return this.__checkIfParentControlReadOnly(parentControl.id);
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			readOnly: this.__isReadOnly()
		};
	}

	__render(children?: React.ReactNode): JSX.Element {
		return super.__render(children);
	}
}
